import ApiService from '../services/ApiService'

const PENDING_EQUIPMENT_KEY = 'equipmentIdQrCode'
const LEGACY_INSTITUTION_KEY = 'equipmentInstitutionId'

export function setPendingQrCode(equipmentId) {
  localStorage.setItem(PENDING_EQUIPMENT_KEY, equipmentId)
}

export function getPendingQrCode() {
  return localStorage.getItem(PENDING_EQUIPMENT_KEY)
}

export function clearPendingQrCode() {
  localStorage.removeItem(PENDING_EQUIPMENT_KEY)
  localStorage.removeItem(LEGACY_INSTITUTION_KEY)
}

export async function checkEquipmentMigration(equipmentId) {
  try {
    const response = await new ApiService().get(
      `equipment/check-migration/${equipmentId}`,
      null,
      false,
      false,
    )

    if (
      response &&
      response.content &&
      response.content.migratedToV2 === true &&
      response.content.redirectUrl
    ) {
      return response.content.redirectUrl
    }
  } catch (err) {}

  return null
}

async function getEquipmentInstitutionId(equipmentId) {
  const response = await new ApiService().get(
    `equipment/getQrCode/${equipmentId}`,
    null,
    false,
  )

  return response && response.content ? response.content.institutionId : null
}

export async function resolveQrCodeRedirect(institutions) {
  const equipmentId = getPendingQrCode()

  if (!equipmentId) return null

  clearPendingQrCode()

  let institutionId = null

  try {
    institutionId = await getEquipmentInstitutionId(equipmentId)
  } catch (err) {
    return {
      path: null,
      institution: null,
      deniedInstitution: false,
      lookupFailed: true,
    }
  }

  const institution = (institutions || []).find(
    (value) => value && value.id == institutionId,
  )

  if (!institution) {
    return {
      path: null,
      institution: null,
      deniedInstitution: true,
      lookupFailed: false,
    }
  }

  return {
    path: `/aboutEquipment/${equipmentId}`,
    institution,
    deniedInstitution: false,
    lookupFailed: false,
  }
}
